import cns from 'classnames';
import pageData from '../../../common/talents/data.json';
import styles from './index.module.less';

function TalentMD() {
  const renderProfile = () => (
    <div className={styles.profile}>
      <div className={styles.title}>{pageData.profile.label}</div>
      <div className={styles.content}>{pageData.profile.content}</div>
    </div>
  );

  const renderBrief = () => (
    <div className={styles.brief}>
      <img src={pageData.brief.imgList[0]} alt="" className={styles.brief__img} />
      <div className={styles.content}>{pageData.brief.content}</div>
      <img src={pageData.brief.imgList[1]} alt="" className={styles.brief__img} />
    </div>
  );

  const classItem = (item: any) => (
    <div key={item.title} className={styles.class__item}>
      <div className={styles['subtitle']}>{item.title}</div>
      {item.imgUrl && <img src={item.imgUrl} className={styles.class__img} alt="" />}
      <div className={cns(styles.content, styles.class__content)}>{item.content}</div>
    </div>
  );

  const renderElementClass = () => (
    <div className={styles.class}>
      <div className={styles.title}>{pageData.elementClass.label}</div>
      {pageData.elementClass.value.map((item) => classItem(item))}
    </div>
  );
  const renderEconomicsClass = () => (
    <div className={styles.class}>
      <div className={styles.title}>{pageData.economicsClass.label}</div>
      {pageData.economicsClass.value.map((item) => classItem(item))}
    </div>
  );

  return (
    <section className={styles.local}>
      {renderProfile()}
      {renderBrief()}
      {renderElementClass()}
      {renderEconomicsClass()}
    </section>
  );
}

export default TalentMD;
